export const en = {
  'duty.endsSoon': 'Your working access ends at {time}. To keep working, clock in or ask your shift manager to extend your time.',
  'duty.offChip': 'Off duty',
  'duty.off': 'Outside your shift you can manage your own leave, hours and shifts.',
  'duty.offSignedOut': 'Your shift has ended. You can clock in or see your shifts.',
  'duty.endedAt': 'Your working access ended at {time}.',
  'duty.next': 'Your next shift starts {when}.',
  'duty.guardTitle': 'You are off duty',
  'duty.guardDescription': 'This page opens during your shift. Clock in, or ask your shift manager to extend your time.',
  'duty.shiftEnded': 'Your shift ended at {time}, so you were signed out. Sign in again to clock in or see your shifts.',
};

export const ka: Record<keyof typeof en, string> = {
  'duty.endsSoon': 'თქვენი სამუშაო წვდომა მთავრდება {time}-ზე. მუშაობის გასაგრძელებლად დააფიქსირეთ მოსვლა ან სთხოვეთ ცვლის მენეჯერს დროის გაგრძელება.',
  'duty.offChip': 'ცვლის გარეთ',
  'duty.off': 'ცვლის გარეთ შეგიძლიათ მართოთ მხოლოდ თქვენი შვებულება, საათები და ცვლები.',
  'duty.offSignedOut': 'თქვენი ცვლა დასრულდა. შეგიძლიათ დააფიქსიროთ მოსვლა ან ნახოთ თქვენი ცვლები.',
  'duty.endedAt': 'თქვენი სამუშაო წვდომა დასრულდა {time}-ზე.',
  'duty.next': 'თქვენი შემდეგი ცვლა იწყება {when}.',
  'duty.guardTitle': 'თქვენ ცვლის გარეთ ხართ',
  'duty.guardDescription': 'ეს გვერდი თქვენი ცვლის დროს იხსნება. დააფიქსირეთ მოსვლა ან სთხოვეთ ცვლის მენეჯერს დროის გაგრძელება.',
  'duty.shiftEnded': 'თქვენი ცვლა დასრულდა {time}-ზე, ამიტომ სისტემიდან გამოხვედით. თავიდან შედით მოსვლის დასაფიქსირებლად ან ცვლების სანახავად.',
};
